module.exports = __webpack_public_path__ + "static/media/termopary3ru.f6cef360.pdf";